// ANCHOR Base
import { Block } from 'baseui/block';
import { ParagraphSmall } from 'baseui/typography';

// ANCHOR Models
import { ConfirmationModalLogic } from '@lyon/scoped-models/confirmation-modal/ConfirmationModalLogic';

// ANCHOR Components
import { constant } from '@lyon/components/utils/constant';

// ANCHOR Styles
import { BLOCK, BODY_CONTENT } from './styles';

export const LyonConfirmationModalBodyDichotomous = constant(() => {
  const description = ConfirmationModalLogic.useSelector(({ state }) => state.description);

  if (!description) {
    return null;
  }

  return (
    <Block overrides={BLOCK}>
      <ParagraphSmall overrides={BODY_CONTENT}>
        {description}
      </ParagraphSmall>
    </Block>
  );
});
